import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { IoLogoWhatsapp } from "react-icons/io";
import { ImMobile } from "react-icons/im";
import { MdEmail } from "react-icons/md";
import { TiPhone } from "react-icons/ti";
import { headApi } from "utils/headApi";

import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceStyle";

const useStyles = makeStyles(invoiceStyle);

export default function BillHeader() {
  const [getItem, setGetItem] = React.useState([]);
  const classes = useStyles();

  const search = useLocation().search;
  const byuserid = new URLSearchParams(search).get("byuserid");

  async function getProd() {
    const get = headApi + `/user/+${byuserid}`;
    const results = await fetch(get);
    const res = await results.json();
    setGetItem(res);
  }

  useEffect(() => {
    getProd();
  }, []);

  return (
    <div className={classes.productPage}>
      <GridContainer className={classes.borderLine}>
        <GridItem md={2} sm={2} xs={2}>
          <img
            src="apple-bangles-org-icon.png"
            style={{ marginTop: "10px", height: "125px" }}
          />
        </GridItem>
        <GridItem
          md={8}
          sm={8}
          xs={8}
          className={
            classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
          }
        >
          <span className={classes.invoiceName}>PROFOMA INVOICE</span>
          <br />
          <span className={classes.companyName}>{getItem.company}</span>
          <br />
          <div className={classes.space}>
            <span className={classes.address}>
              {getItem.address} {getItem.address1} {getItem.address2}{" "}
              {getItem.address3}
              <br />
              {getItem.city} {"-"} {getItem.zipcode}, {getItem.state}, INDIA.
              <br />{" "}
              <strong className={classes.gst}>
                GSTIN : {getItem.gstno}
              </strong>{" "}
              <TiPhone /> {getItem.office} <br />
            </span>
            <span className={classes.mobileTel}>
              <ImMobile /> {getItem.mobile} <IoLogoWhatsapp />{" "}
              {getItem.whatsapp} <MdEmail /> {getItem.email}
            </span>
          </div>
        </GridItem>
        <GridItem md={2} sm={2} xs={2} className={classes.originalCopy}>
          <span>Original Copy</span>
        </GridItem>
      </GridContainer>
    </div>
  );
}
